export enum MultiTenancyProfile {
  CH = 'ch',
  DE = 'de' // de
}
